import React, { Fragment } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const GestionActual = () => {
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const { datosGestion} = data_recepciona
  const data_cambiarGestion = useSelector((state) => state.cambiarGestionReducer)
  const { cfg_form13 } = data_cambiarGestion
  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{cfg_form13 && cfg_form13.cfg_form13['cambiotipogestion-title-gestactual']}</div>
      {cfg_form13 &&<Container>
        <Row>
          <Col>
          <Form.Label
              className='mt-3'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-lbl-tipogestion']}
            </Form.Label>  
            <br></br>  
              <Form.Text className="mt-3 mx-1">
                        {datosGestion && datosGestion.datosGestion[0]["tipoGestion"]}
              </Form.Text>           
          </Col>
          <Col>
          <Form.Label
              className='mt-3'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-lbl-ambitogest']}
            </Form.Label> 
            <br></br>     
            <Form.Text className="mt-3 mx-1">
                        {datosGestion && datosGestion.datosGestion[0]["ambitoGestion"]}
              </Form.Text>
              
          </Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
        </Row>
        <hr style={{color:"#04005D", height: "2px"}}></hr>
      </Container>}
    </>
  )
}

export default GestionActual
